import { config } from 'data';
import { countryService } from 'services';
import { useQuery } from 'hooks';

const useAllCountriesQuery = () => useQuery({
  queryKey: [config.COUNTRIES_QUERY_KEY, 'all'],
  queryFn: () => countryService.getCountries(),
  refetchOnMount: false,
  refetchOnWindowFocus: false,
});

export default useAllCountriesQuery;
